import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { router } from './Routes';
import './index.css';
import { analytics, withErrorBoundary } from './insfrastructure/services/analytics';

// Inicializar analytics e Sentry antes de qualquer componente React
analytics.initialize();

// Componente principal com Error Boundary
const AppWithErrorBoundary = withErrorBoundary(() => (
  <RouterProvider router={router} />
));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <AppWithErrorBoundary />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
